
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class MailDtoModel extends Model<MailDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'mailDto.property.companyId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'mailDto.property.taskflowId' },
		{ name: 'taskActionId', type: 'guid', languageString: 'mailDto.property.taskActionId' },
		{ name: 'subject', type: 'string', languageString: 'mailDto.property.subject' },
		{ name: 'content', type: 'string', languageString: 'mailDto.property.content' },
		{ name: 'recipients', type: 'string[]', languageString: 'mailDto.property.recipients', isArray: true },
		{ name: 'mailData', type: 'string', languageString: 'mailDto.property.mailData' },
		{ name: 'trackingId', type: 'string', languageString: 'mailDto.property.trackingId' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public taskflowId?: string;
	public taskActionId?: string;
	public subject: string;
	public content: string;
	public recipients: string[];
	public mailData: string;
	public trackingId?: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.taskflowId = undefined;
		this.taskActionId = undefined;
		this.subject = '';
		this.content = '';
		this.recipients = [];
		this.mailData = '';
		this.trackingId = undefined;
		
	}
	getProperties(){
		return MailDtoModel.classProperties;
	}
}

